import { createScale } from '../internal';
export const systolicBloodPressureBounds = [{
  lower: 0,
  upper: 90,
  score: {
    type: 'low',
    value: 3
  }
}, {
  lower: 91,
  upper: 100,
  score: {
    type: 'low',
    value: 2
  }
}, {
  lower: 101,
  upper: 110,
  score: {
    type: 'low',
    value: 1
  }
}, {
  lower: 111,
  upper: 219,
  score: {
    type: 'normal',
    value: 0
  }
}, {
  lower: 220,
  upper: Infinity,
  score: {
    type: 'high',
    value: 3
  }
}];
/**
 * Systolic Blood Pressure (mmHg) `integer`
 */

export const systolicBloodPressure = createScale(systolicBloodPressureBounds, 0);
//# sourceMappingURL=systolic-blood-pressure.js.map